import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Hero } from '../components/Hero';
import { Solutions } from '../components/Solutions';
import { CommChannels } from '../components/CommChannels';
import { Process } from '../components/Process';
import { LeadForm } from '../components/LeadForm';
export function HomePage() {
    return (_jsxs(_Fragment, { children: [_jsx(Hero, {}), _jsx(Solutions, {}), _jsx(CommChannels, {}), _jsx(Process, {}), _jsx(LeadForm, {})] }));
}
